import { useFormContext } from 'react-hook-form'
import { useLingui } from '@lingui/react/macro'

import {
	EditAvailabilitiesForm,
	type EditAvailabilityFormData,
} from '../../event-types/availabilities-form'
import type { EditEventTypeFormData } from '../../event-types/edition/event-type-form'

export const WorkingHoursList = ({ onSubmit }: { onSubmit?: VoidFunction }) => {
	const { t } = useLingui()
	const form = useFormContext<EditEventTypeFormData>()

	const handleSubmit = (data: EditAvailabilityFormData) => {
		form.setValue('availabilities', data, {
			shouldDirty: true,
		})

		onSubmit?.()
	}

	return (
		<div className='flex flex-col gap-y-4'>
			<p className='text-muted-foreground text-sm'>
				{t`Définissez vos heures de travail régulières pour chaque jour de la semaine`}
			</p>

			<EditAvailabilitiesForm
				availabilities={form.getValues('availabilities')}
				onClose={onSubmit}
				onSubmit={handleSubmit}
			/>
		</div>
	)
}
